/**
 * Authentication Context
 * Manages user authentication state globally
 */

import { createContext, useState, useEffect } from 'react';
import { authService } from '../api/services/authService';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in on mount
    const initAuth = async () => {
      const token = localStorage.getItem('accessToken');
      const storedUser = localStorage.getItem('user');
      
      if (token && storedUser) {
        try {
          // Load user from localStorage first (for immediate access)
          const parsedUser = JSON.parse(storedUser);
          setUser(parsedUser);
          
          // Then verify with server (optional, for session validation)
          // Uncomment if you want to verify on every load:
          // const response = await authService.getCurrentUser();
          // setUser(response.data);
        } catch (error) {
          console.error('Failed to restore user session:', error);
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('user');
        }
      }
      
      setLoading(false);
    };

    initAuth();
  }, []);

  const login = async (credentials) => {
    const response = await authService.login(credentials);
    setUser(response.data.user);
    return response;
  };

  const logout = async () => {
    await authService.logout();
    setUser(null);
    localStorage.removeItem('user');
  };

  const register = async (userData) => {
    const response = await authService.register(userData);
    return response;
  };

  const value = {
    user,
    loading,
    login,
    logout,
    register,
    setUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

